var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 112C80 112 80 99.8933 80 96C80 92.64 80.8 85.5467 77.3333 82.6667C84.7467 81.9733 90.56 79.5733 96 74.6667C101.44 69.76 104 62.3467 104 50.6667C104 42.6667 102.667 37.3333 98.6667 32C100.213 27.84 100.48 21.3333 98.6667 16C90.3467 16 82.8267 21.7067 80 24C77.92 23.4667 72.9067 21.3333 64 21.3333C55.0933 21.3333 50.08 23.4667 48 24C45.1733 21.7067 37.6533 16 29.3333 16C27.52 21.3333 27.7867 27.84 29.3333 32C25.3333 37.3333 24 42.6667 24 50.6667C24 62.3467 26.56 69.76 32 74.6667C37.44 79.5733 43.2533 81.9733 50.6667 82.6667C47.2 85.5467 48 92.64 48 96C48 99.8933 48 112 48 112",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 101.333C40.48 101.333 32.8533 98.3466 28.32 94.9866C23.84 91.6266 22.5067 86.1333 16 82.6666",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.83caf0ce52c507fb3786fc01d6adf5b2.svg";
export { ForwardRef as ReactComponent };